<template>
  <div class="timetable-switcher" :class="{ right: model === 'list' }">
    <label class="button" :class="{ active: model === 'grid' }">
      <input
        id="grid"
        v-model="model"
        class="input"
        type="radio"
        value="grid"
        v-bind="$attrs"
      />
      <GridIcon class="icon icon--18" />
      <span class="t-p-s-130">{{ t('timetable.grid') }}</span>
    </label>
    <label class="button" :class="{ active: model === 'list' }">
      <input
        id="list"
        v-model="model"
        class="input"
        type="radio"
        value="list"
        v-bind="$attrs"
      />
      <ListIcon class="icon icon--18" />
      <span class="t-p-s-130">{{ t('timetable.list') }}</span>
    </label>
  </div>
</template>

<script lang="ts" setup>
import GridIcon from '@/assets/icons/grid.svg?component'
import ListIcon from '@/assets/icons/list.svg?component'

const { t } = useI18n()

const model = defineModel<'list' | 'grid'>()
</script>

<style lang="scss" scoped>
.timetable-switcher {
  position: relative;
  display: inline-flex;
  height: rem(44px);
  margin-bottom: rem(42px);
  overflow: hidden;
  background-color: $layout-background-02;
  border-radius: $border-radius-mid;

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    content: '';
    background-color: $global-sun-01;
    border: rem(3px) solid $layout-background-02;
    border-radius: $border-radius-mid;
    transition: left $transition;
  }

  &.right::after {
    left: 50%;
  }
}

.input {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
}

.button {
  z-index: 1;
  display: flex;
  column-gap: rem(8px);
  align-items: center;
  justify-content: space-between;
  padding: rem(10px) rem(22px) rem(10px) rem(20px);
  cursor: pointer;

  &.active {
    color: $layout-text-white;
  }
}
</style>
